import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appToggleDropdown]'
})
export class hideShowDropdownDirective {
  @Input() appToggleDropdown: any; // The dropdown reference
  @Input() isSmallScreen = false;

  @HostListener('click')
  onClick() {
    if (!this.isSmallScreen && this.appToggleDropdown) {
      this.appToggleDropdown.overlayVisible
        ? this.appToggleDropdown.hide()
        : this.appToggleDropdown.show();
    }
  }
}
